import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PanelUserDetailStyle } from './PanelUserDetailStyle';
import ListUserDetail from './component/ListUserDetail';
import { Box, Grid, Paper, Table, TableCell, TableHead, TableRow, Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import MigaPan from '../../app/orussystem/component/MigaPan';
import { getUsersMachineBasculaDetail } from '../domain/api/UsersApi';
import { useDispatch } from 'react-redux';
import { UtilsDate } from '../../app/orussystem/utils/UtilDate';
import { DATE_END, DATE_INIT } from '../../app/api-client/constants';
import FiltroDetalleUser from '../component/GeneriBascula.js/filtroDetalle';
import DetalleUser from '../component/GeneriBascula.js/detalleUser';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export const PanelUserDetail = (props) => {

    const classes = PanelUserDetailStyle();
    let init_date = localStorage.getItem(DATE_INIT);
    let end_date = localStorage.getItem(DATE_END)
    const [UsersMachine, setUsersMachine] = useState([]);
    const [isLoadUser] = useState(false);
    const [page, setPage] = useState(0)
    const [size] = useState(20)
    const [totalElements] = useState(0)

    const [dateInit, setDateInit] = useState(init_date)
    const [dateEnd, setDateEnd] = useState(end_date)
    const [infoBascula] = useState({ maxUser: 0, genero: [], genericIESs: [] });
    const [dataPorcentage] = useState("-")
    const [dataTotal, setdataTotal] = useState("-")
    const [datatotal_users] = useState("-")
    //Filtrar por usuarii
    const [userPhone, setuserPhone] = useState("")
    const [userCedula, setuserCedula] = useState("")


    const dispatch = useDispatch();
    const location = useLocation();

    let { id } = useParams();
    const { nameBascula } = location.state;
    const fixedHeightFilter = clsx(classes.paper, classes.fixedHeightFilter);

    const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 0 : id;


    const getDataTable = async (idBascula, dateInit, dateEnd) => {

        const pageBascula = await getUsersMachineBasculaDetail(dispatch, idBascula, dateInit, sumaDia(dateEnd));

        try {
            setUsersMachine(pageBascula.respuesta);
            setdataTotal(pageBascula.respuesta.length);
            // settotalElements(pageBascula.totalElements);
        } catch (err) {
            console.log("Ocurrio un error", err)
        }
    }


    useEffect(async () => {
        // Ajustar la fecha de inicio y fin al cargar el componente
        const adjustedDateEnd = new Date(dateEnd);
        adjustedDateEnd.setDate(adjustedDateEnd.getDate() - 1);

        getDataTable(idBascula, dateInit, adjustedDateEnd);
    }, [dateInit, dateEnd]);




    const reloadPage = () => {
        getDataTable(dateInit, dateEnd)
    }

    const downloadReport = (dataStart, dataEnd) => {
        window.open(`${process.env.REACT_APP_API_EVBI}/v1/data/export/report/user/dates/${idBascula}/${dataStart}/${dataEnd}`);
    }

    const sumaDia = (date) => {
        let init = new Date(date);
        init = init.getTime();
        init = init + 172800000
        init = new Date(init)
        init = UtilsDate().formatYYYYMMdd(init)
        return init
    }

    const handlerFilter = (dataStart, dateEnd) => {
        // Sumar un día a la fecha final
        const nextDay = new Date(dateEnd);
        nextDay.setDate(nextDay.getDate() + 1);

        // Actualizar los estados con las fechas formateadas
        setDateEnd(UtilsDate().formatYYYYMMdd(nextDay));
        setDateInit(UtilsDate().formatYYYYMMdd(dataStart));
    };
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;

    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage={`Usuarios Bascula ${nameBascula}`}
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas/"
                    namePage3={`Detalles ${nameBascula}`}
                    to3={{
                        pathname: `/basculas/mediciones/${idBascula}`,
                        state: { nameBascula: nameBascula },
                    }}

                >
                    Home
                </MigaPan>
            </Grid>

            <Grid item xs={12} md={12} lg={9}>
                <Paper className={fixedHeightFilter} style={{ minHeight: "100%" }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} lg={12} style={{ marginBottom: 20 }}>

                            <FiltroDetalleUser
                                handlerFilter={handlerFilter}
                                isLoading={isLoadUser}
                                isDate={true}
                                reloadTable={reloadPage}
                                filter={userPhone}
                                setFilter={setuserPhone}
                                filterCedula={userCedula}
                                setFilterCedula={setuserCedula}
                                filtrar={() => { }}
                                dowload={downloadReport}
                                fecha

                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>


            <Grid xs={12} md={12} lg={3}>
                <Paper className={fixedHeightFilter} style={{ maxHeight: "100%", marginTop: "0.8rem" }}>
                    <DetalleUser
                        max={infoBascula.maxUser}
                        dataBascula={nameBascula}
                        porcentage={dataPorcentage}
                        total={dataTotal}
                        total_users={datatotal_users} />
                </Paper>
            </Grid>
            <Paper className={classes.paper1} >
                <Grid item xs={12}>
                    <Box
                        component="span"
                        m={1}
                        className={`${classes.spreadBox} ${classes.box}`}
                    >

                        <Grid container alignItems="center" justifyContent='center' >
                            <Grid item>
                                <Grid item xs={12} sm container >
                                    <Grid item xs container direction="column"  >
                                        <Grid item xs>
                                            <Typography align="center" justify="center" style={{ fontWeight: 'bold', fontSize: "45px" }} color='primary' >
                                                Resultados
                                            </Typography>
                                            <Grid item xs={12} sm container alignItems="center" justifyContent="center" >
                                                <Typography component="p" align="center">
                                                    {dateInit}
                                                </Typography>

                                                <Typography component="p" align="right" style={{ marginLeft: '10px' }}>
                                                    {dateEnd}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Table>
                        <TableHead color='primary'>
                            <TableRow color='primary'>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '1%', width: '12%', color: primaryColor }}>Identificacion</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '8%', color: primaryColor }}>Nombre</TableCell>
                                <TableCell className={classes.TableCell} style={{ width: '8%', paddingLeft: '2%', color: primaryColor }}>Celular</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0.5%', width: '5%', color: primaryColor }}>Género</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0.5%', width: '5%', color: primaryColor }}>Peso</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0.5%', width: '5%', color: primaryColor }}>Altura</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '10%', color: primaryColor }}>Presión Arterial (mmHg)</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '5%', color: primaryColor }}>Imc</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '5%', color: primaryColor }}>Porcentaje de Grasa</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '5%', color: primaryColor }}>SpO2</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '5%', color: primaryColor }}>Edad</TableCell>
                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '5%', color: primaryColor }}>IES</TableCell>

                            </TableRow>
                        </TableHead>


                    </Table>

                </Grid>
                <Grid item xs={12}>


                    <ListUserDetail
                        rows={UsersMachine}
                        isLoadUser={isLoadUser}
                        page={page}
                        size={size}
                        totalElement={totalElements}
                        setPage={setPage}
                        fechaIni={dateInit}
                        fechaFin={dateEnd}
                        pageBascula={UsersMachine}

                    />
                </Grid>
            </Paper>
        </>


    )



}